'use strict';
import * as $i_$0040ui5$002fwebcomponents$002fdist$002fCheckBox$002ejs from "@ui5/webcomponents/dist/CheckBox.js";
import * as $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent from "./io.github.nguyenyou.ui5.webcomponents.laminar.shared.-Web-Component.js";
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$() {
  this.dz = null;
  this.cu = null;
  this.dV = null;
  this.dW = false;
  $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$ct_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent__T__(this, "ui5-checkbox");
}
export { $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$ as $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$ };
$p = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$.prototype = new $j_io$002egithub$002enguyenyou$002eui5$002ewebcomponents$002elaminar$002eshared$002e$002dWeb$002dComponent.$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_shared_WebComponent();
$p.constructor = $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$;
/** @constructor */
function $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$() {
}
export { $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$ as $h_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$ };
$h_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$.prototype = $p;
$p.cQ = (function() {
  return $i_$0040ui5$002fwebcomponents$002fdist$002fCheckBox$002ejs.default;
});
var $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$, "io.github.nguyenyou.ui5.webcomponents.laminar.CheckBox$", ({
  jA: 1,
  ac: 1
}));
export { $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$ as $d_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$ };
var $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$;
function $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$() {
  if ((!$n_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$)) {
    $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$ = new $c_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$();
  }
  return $n_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$;
}
export { $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$ as $m_Lio_github_nguyenyou_ui5_webcomponents_laminar_CheckBox$ };
